import React from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Separator } from './ui/separator';
import { ScrollArea } from './ui/scroll-area';
import { Settings, LogOut, Monitor, AlertTriangle, Battery, CreditCard, ArrowLeft, } from 'lucide-react';

export default function CookingSessions({
    settings,
    onSettingsChange,
    backToJobs,
    onNavigateToJobs,
    onLogout
}) {
    const updateSetting = (key, value) => {
        onSettingsChange({
            ...settings,
            [key]: value
        });
    };

    return (
        <div className="min-h-screen bg-background">
            {/* Header */}
            <div className="border-b bg-card">
                <div className="container mx-auto px-4">
                    <div className="flex items-center justify-between h-16">
                        <div className="flex items-center space-x-2">
                            <Settings className="h-6 w-6" />
                            <h1 className="text-lg font-medium">System Settings</h1>

                        </div>

                        <div className="flex items-center space-x-2">
                            <Button
                                variant="default"
                                size="sm"
                                onClick={backToJobs}
                                className="flex items-center space-x-1"
                                style={{ backgroundColor: '#1a73e8', color: '#ffffff' }}
                            >
                                <Monitor className="h-4 w-4" />
                                <span>Back to logs</span>
                            </Button>
                            <Button
                                variant="default"
                                size="sm"
                                onClick={onNavigateToJobs}
                                className="flex items-center space-x-1"
                                style={{ backgroundColor: '#1a73e8', color: '#ffffff' }}
                            >
                                <Monitor className="h-4 w-4" />
                                <span>Jobs Monitor</span>
                            </Button>
                            <Button
                                variant="destructive"
                                size="sm"
                                onClick={onLogout}
                                className="flex items-center space-x-1"
                                style={{ backgroundColor: '#ea4335', color: '#ffffff' }}
                            >
                                <LogOut className="h-4 w-4" />
                                <span>Logout</span>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <div className="container mx-auto px-4 py-8">

                <div className="max-w-4xl mx-auto space-y-6">
                    <ScrollArea className="h-[calc(100vh-200px)]">
                        <div className="space-y-6 pr-4">
                            {/* System Parameters */}
                            <Card>
                                <CardHeader>
                                    <CardTitle>System Parameters</CardTitle>
                                    <CardDescription>
                                        Configure monitoring intervals and system settings
                                    </CardDescription>
                                </CardHeader>
                                <CardContent className="space-y-6">

                                </CardContent>
                            </Card>

                            {/* Device Information */}
                            <Card>
                                <CardHeader>
                                    <CardTitle className="flex items-center space-x-2">
                                        <Monitor className="h-5 w-5" />
                                        <span>Device Information</span>
                                    </CardTitle>
                                    <CardDescription>
                                        Configure device identifiers and serial numbers
                                    </CardDescription>
                                </CardHeader>
                                <CardContent className="space-y-6">
                                    {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div className="space-y-2">
                                            <Label htmlFor="cardId">Card ID (Optional)</Label>
                                            <Input
                                                id="cardId"
                                                type="text"
                                                value={settings.cardId}
                                                onChange={(e) => updateSetting('cardId', e.target.value)}
                                                placeholder="Optional field"
                                            />
                                            <p className="text-xs text-muted-foreground">
                                                This field is not compulsory
                                            </p>
                                        </div>

                                        <div className="space-y-2">
                                            <Label htmlFor="customerId">Customer ID</Label>
                                            <Input
                                                id="customerId"
                                                type="text"
                                                value={settings.customerId}
                                                onChange={(e) => updateSetting('customerId', e.target.value)}
                                                placeholder="CUST001"
                                            />
                                        </div>

                                        <div className="space-y-2">
                                            <Label htmlFor="cylinderSerial">Cylinder Serial</Label>
                                            <Input
                                                id="cylinderSerial"
                                                type="text"
                                                value={settings.cylinderSerial}
                                                onChange={(e) => updateSetting('cylinderSerial', e.target.value)}
                                                placeholder="CYL123456"
                                            />
                                        </div>

                                        <div className="space-y-2">
                                            <Label htmlFor="batteryModel">Battery Model</Label>
                                            <Input
                                                id="batteryModel"
                                                type="text"
                                                value={settings.batteryModel}
                                                onChange={(e) => updateSetting('batteryModel', e.target.value)}
                                                placeholder="Li-Ion 3.7V"
                                            />
                                        </div>

                                        <div className="space-y-2">
                                            <Label htmlFor="batterySerial">Battery Serial Number</Label>
                                            <Input
                                                id="batterySerial"
                                                type="text"
                                                value={settings.batterySerial}
                                                onChange={(e) => updateSetting('batterySerial', e.target.value)}
                                                placeholder="BAT789012"
                                            />
                                        </div>
                                    </div> */}
                                </CardContent>
                            </Card>

                            {/* Warning Thresholds */}
                            <Card>
                                <CardHeader>
                                    <CardTitle className="flex items-center space-x-2">
                                        <AlertTriangle className="h-5 w-5" />
                                        <span>Warning Thresholds</span>
                                    </CardTitle>
                                    <CardDescription>
                                        Configure warning levels for battery and credit
                                    </CardDescription>
                                </CardHeader>
                                <CardContent className="space-y-6">
                                    {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div className="space-y-2">
                                            <Label htmlFor="warningLowBattery" className="flex items-center space-x-2">
                                                <Battery className="h-4 w-4" />
                                                <span>Warning Low Battery (%)</span>
                                            </Label>
                                            <Input
                                                id="warningLowBattery"
                                                type="number"
                                                min="0"
                                                max="100"
                                                value={settings.warningLowBattery}
                                                onChange={(e) => updateSetting('warningLowBattery', parseInt(e.target.value))}
                                                placeholder="20"
                                            />
                                            <p className="text-xs text-muted-foreground">
                                                Battery percentage threshold for warnings
                                            </p>
                                        </div>

                                        <div className="space-y-2">
                                            <Label htmlFor="warningLowCredit" className="flex items-center space-x-2">
                                                <CreditCard className="h-4 w-4" />
                                                <span>Warning Low Credit</span>
                                            </Label>
                                            <Input
                                                id="warningLowCredit"
                                                type="number"
                                                step="0.01"
                                                value={settings.warningLowCredit}
                                                onChange={(e) => updateSetting('warningLowCredit', parseFloat(e.target.value))}
                                                placeholder="5.00"
                                            />
                                            <p className="text-xs text-muted-foreground">
                                                Credit amount threshold for warnings
                                            </p>
                                        </div>
                                    </div> */}
                                </CardContent>
                            </Card>

                            <Separator />

                            <div className="flex justify-end">
                                <Button>Save Settings</Button>
                            </div>

                            {/* System Status */}
                            <Card>
                                <CardHeader>
                                    <CardTitle>System Status</CardTitle>
                                    <CardDescription>
                                        Current system configuration overview
                                    </CardDescription>
                                </CardHeader>
                                <CardContent>
                                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 text-sm">
                                        {/* <div>
                                            <div className="font-medium text-muted-foreground">Monitoring Frequency</div>
                                            <div>{settings.upPeriod} minutes</div>
                                        </div>
                                        <div>
                                            <div className="font-medium text-muted-foreground">Start Period</div>
                                            <div>{settings.startPeriod} minutes</div>
                                        </div>
                                        <div>
                                            <div className="font-medium text-muted-foreground">Gas Level</div>
                                            <div>{settings.gasLevel} kg</div>
                                        </div>
                                        <div>
                                            <div className="font-medium text-muted-foreground">Customer ID</div>
                                            <div>{settings.customerId}</div>
                                        </div> */}
                                    </div>
                                </CardContent>
                            </Card>
                        </div>
                    </ScrollArea>
                </div>
            </div>
        </div>
    );
}